// Model
import { Banner } from './../models/banner.model';
import { ApiResponse } from '../models/api-response.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { WebsocketService } from './websocket.service';
import { Livechat } from '@core/models/livechat.model';

@Injectable({
  providedIn: 'root'
})
export class LivechatHttpService {

  private liveChatScript$ = new Subject<Livechat>();

  constructor(private http: HttpClient, private websocketService: WebsocketService) { }

  getLiveChatScript(Param: string): Observable<any> {
    return this.http.get<ApiResponse>(`/livechat/getscript${Param}`).pipe(
      map(res => {
        const rows = res.data?.rows || {};
  
        const liveChatScript = {
          website: rows.website || '',
          chat_page: rows.chat_page || '',
          live_chat_platform_id: rows.live_chat_platform_id || '',
          live_chat_platform_name: rows.live_chat_platform_name || '',
          live_chat_locale_id: rows.live_chat_locale_id || '',
          language_code: localStorage.getItem('language_code') || '',
          country_code: localStorage.getItem('country_code') || '',
          member_groups: rows.member_groups || []
        };

        sessionStorage.setItem('live_chat_script', JSON.stringify(liveChatScript));
        this.liveChatScript$.next(liveChatScript);
        return res.data;
      }),
    );
  }

  liveChatScriptWebsocket() {
    this.websocketService
      .getChannel('update-live-chat-channel')
      .listen('.UpdateLiveChatEvent', (liveChat: any) => {
        const newLiveChat : Livechat = {
          live_chat_locale_id: liveChat.live_chat_locale_id,
          website: liveChat.website,
          chat_page: liveChat.chat_page,
          live_chat_platform_id: liveChat.live_chat_platform_id,
          live_chat_platform_name: liveChat.live_chat_platform_name,
          language_code: liveChat.language_code || '',
          country_code: liveChat.country_code || '',
          member_groups: liveChat.member_groups || []
        };
        const storedLiveChat = this.getLiveChatScriptFromSession();
        const languageCode = localStorage.getItem('language_code') || '';
        const countryCode = localStorage.getItem('country_code') || '';
        const memberGroupCode = localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data'))?.member_group?.code?.toLowerCase() || '' : '';
        const newMemberGroups: string[] = newLiveChat?.member_groups || [];
        const newAllMemberGroups: string[] = liveChat?.all_live_chat_member_groups || [];
        const currentLiveChatLocales: string[] = liveChat?.current_live_chat_locales || [];
        const isGuest = !memberGroupCode;
        const localeKey = `${countryCode}_${languageCode}`; // e.g., 'MY_ZH'

         // Check if live_chat_local_id matches and if script and changes to country and language
         const isDifferentContent =
         storedLiveChat &&
         storedLiveChat.live_chat_locale_id === newLiveChat.live_chat_locale_id &&
         (storedLiveChat.website !== newLiveChat.website ||
           storedLiveChat.language_code !== localStorage.getItem('language_code') ||
           storedLiveChat.country_code !== localStorage.getItem('country_code'));

        // Check member group existence
        const memberGroupExists = isGuest
        ? newMemberGroups.some(group => group.toLowerCase() === 'normal')
        : newMemberGroups.some(group => group.toLowerCase() === memberGroupCode);

        const allMemberGroupExists = isGuest
        ? newAllMemberGroups.some(group => group.toLowerCase() === 'normal')
        : newAllMemberGroups.some(group => group.toLowerCase() === memberGroupCode);

        // Check if current live chat locale have value for current user locale
        const existsInLocales = currentLiveChatLocales.includes(localeKey);

        // Conditions
        const shouldUnsetLiveChat = (!allMemberGroupExists && storedLiveChat.website !== '') || (allMemberGroupExists && !existsInLocales && memberGroupExists);
        const shouldUpdateLiveChat = allMemberGroupExists && memberGroupExists && liveChat.language_code === languageCode && liveChat.country_code === countryCode && storedLiveChat.website !== newLiveChat.website;
        
        if (shouldUnsetLiveChat) {
          // If user member group not exist in all others live chat then unset livechat
          const emptyLiveChatScript : Livechat = {
            website: '',
            chat_page: '',
            live_chat_platform_id: null,
            live_chat_platform_name: '',
            live_chat_locale_id: '',
            language_code: languageCode || '',
            country_code: countryCode || '',
            member_groups: []
          };
          sessionStorage.setItem('live_chat_script', JSON.stringify(emptyLiveChatScript));
          this.liveChatScript$.next(emptyLiveChatScript);
        } else if (shouldUpdateLiveChat || isDifferentContent) {
          sessionStorage.setItem('live_chat_script', JSON.stringify(newLiveChat));
          this.liveChatScript$.next(newLiveChat);
        }
      });
  }

  getScriptUpdates() {
    return this.liveChatScript$.asObservable();
  }

  getLiveChatScriptFromSession(key?: string): any {
    const liveChatScript = JSON.parse(sessionStorage.getItem('live_chat_script') || '{}');
    return key ? liveChatScript[key] : liveChatScript;
  }

  updateLiveChatScriptInSession(key: string, value: string): void {
    const liveChatScript = this.getLiveChatScriptFromSession();
    liveChatScript[key] = value;
    sessionStorage.setItem('live_chat_script', JSON.stringify(liveChatScript));
  }
}
